import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Zones from "@/pages/Zones";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import Guides from "@/pages/Guides";
import GuideDetail from "@/pages/GuideDetail";
import Promos from "@/pages/Promos";
import AdminPromos from "@/pages/AdminPromos";
import Simulator from "@/pages/Simulator";
import LocalPage from "@/pages/LocalPage";
import NotFound from "@/pages/NotFound";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import UrgencyBar from "@/components/UrgencyBar";
import FloatingCallButton from "@/components/FloatingCallButton";
import MobileStickyBar from "@/components/MobileStickyBar";
import ChatbotWidget from "@/components/ChatbotWidget";
import SecurityPopup from "@/components/SecurityPopup";
import ScrollToTop from "@/components/ScrollToTop";
import SourceTracker from "@/components/SourceTracker";
import { zones } from "@/data/zones";

const AppLayout = ({ children }) => (
  <div className="min-h-screen bg-white text-brand-ink flex flex-col">
    <UrgencyBar />
    <Header />
    <main className="flex-1 pb-20 md:pb-0">{children}</main>
    <Footer />
    <MobileStickyBar />
    <ChatbotWidget />
    <SecurityPopup />
    <FloatingCallButton />
    <Toaster richColors position="top-right" />
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
        <BrowserRouter>
          <ScrollToTop />
          <SourceTracker />
          <AppLayout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:serviceSlug" element={<ServiceDetail />} />
              <Route path="/zones" element={<Zones />} />
              <Route path="/guides" element={<Guides />} />
              <Route path="/guides/:guideSlug" element={<GuideDetail />} />
              <Route path="/actualites" element={<Promos />} />
              <Route path="/simulateur" element={<Simulator />} />
              <Route path="/admin/promos" element={<AdminPromos />} />
              <Route path="/a-propos" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/mentions-legales" element={<Legal />} />
              {zones.map((zone) => (
                <Route key={zone.slug} path={`/${zone.slug}`} element={<LocalPage zone={zone} />} />
              ))}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AppLayout>
        </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
